import moment, { Moment } from "moment";
import { QueryParamConfig } from "serialize-query-params/esm/types";
import { decodeDate, encodeDate } from "use-query-params";

export type MomentValue = Moment | null | undefined;

const encodeMoment = (date: MomentValue): string | null | undefined => {
  if (!date) {
    return date;
  }
  return date.format("YYYY-MM-DD");
};

const decodeMoment = (input: string | (string | null)[] | null | undefined): MomentValue => {
  const date = decodeDate(input);
  if (!date) {
    return date;
  }
  return moment.utc(encodeDate(date)).startOf("day");
};

const equalsMoment = (valueA: MomentValue, valueB: MomentValue) => {
  if (!valueA || !valueB) {
    return valueA === valueB;
  }
  return valueA.isSame(valueB);
};

export const MomentParam: QueryParamConfig<MomentValue, MomentValue> = {
  encode: encodeMoment,
  decode: decodeMoment,
  equals: equalsMoment,
};
